import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback, useDeferredValue, useMemo, useState } from "react";
import searchInventoryItems from "@/domains/inventory/helpers/searchInventoryItems";

export default function useSearchItems(items: InventoryItem[]) {
  const [searchValue, setSearchValue] = useState("");

  const onChangeSearchValue = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const deferredSearchValue = useDeferredValue(searchValue);

  const itemsBySearch = useMemo(() => {
    return searchInventoryItems(items, deferredSearchValue);
  }, [deferredSearchValue, items]);

  return {
    searchValue,
    deferredSearchValue,
    onChangeSearchValue,
    itemsBySearch,
  };
}
